import { NetworkBase } from './Network';
import { async, BehaviorSubject } from 'rxjs';
import { CreateCacheItem } from '../Models/Cache.interface';

import { getVideoURL } from '../Constants';
import { includes } from 'lodash';
import { ProgramModel } from '../Models/Program.interface';


export type DataContextType = {
    programs?: ProgramModel[]
}




export class DataManagement extends NetworkBase{
    _cache = new Map()

    get = async (path: string, raw: boolean = false) => {
        let data = this._cache.get(path)
        let subject = new BehaviorSubject(data?.response)
        this._getData(path, subject, raw)
        return subject
    }

    getPromise = async (path: string) => {
        return this._get(path)
    }

    private _getData = async (path: string, subject: BehaviorSubject<any>, raw: boolean = false) => {
        try{
            let response = raw ?  await this._getRaw(path) : await this._get(path)
            subject.next(response)
            let cacheItem = CreateCacheItem(response)
            this._cache.set(path, cacheItem)
        } catch(e) {
            console.log(e)

        }
        subject.complete()
        return
    }

    getVideo = async  (url: string) => {
        try{
            let response = await this._post("/video", {url})
            console.log(response)
            return response.body
        } catch(e) {
            console.error(e)
            return Promise.reject(e.message)
        }
        
    }

    checkIfm3U8 = async (url) => {
        try{
            // console.log("Getting Response for ", url)
            let response = await this.api.head(url)
            // console.log('received Response', response)
            let result =  includes(response?.originalResponse?.url, 'm3u8') ? response.originalResponse.url : null
            // console.log('has m3u8 is', result)
            return result
        } catch(e) {
            console.error(e)
        }
    }

    // getLiveStream = async () => {
    //     let path = await getVideoURL('live')
    //     let response = await this.api.head(path)
    //     return response.originalResponse.url
    // }

    getLiveStream = async () => {
        return this._get("/live")
    }

    getEveryWord = async (date) => {

    }

    search = async (q: string) => {
        let response = await this.getPromise(`/search?q=${q}`)
        return response
    }
}

export const Database = new DataManagement()


